import { render, staticRenderFns } from "./constructionWaste.vue?vue&type=template&id=0bd10b55&scoped=true&"
import script from "./constructionWaste.vue?vue&type=script&lang=js&"
export * from "./constructionWaste.vue?vue&type=script&lang=js&"
import style0 from "./constructionWaste.vue?vue&type=style&index=0&id=0bd10b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd10b55",
  null
  
)

export default component.exports